var Model = require('../Model');

var feeds = Object.create(Model);

feeds.name = 'Feeds';
feeds['@class'] = 'Feeds';
feeds.url = 'feeds';
feeds.isEdge = true;
feeds.fields = {
  serviceClass: {
    default: null,
    hidden: true,
    section: 'Properties',
  },
  category: {
    default: null,
    hidden: true,
    section: 'Properties',
  },
  pointsLinked: {
    default: [],
    hidden: true,
    section: 'Diagram',
  },
  formula: {
    default: null,
    hidden: true,
    section: 'Diagram',
  },
  maxValue: {
    default: null,
    hidden: true,
    section: 'Diagram',
  },
  minValue: {
    default: null,
    hidden: true,
    section: 'Diagram',
  },
  fromNode:{
    default: null,
    hidden: true,
    section: 'Advanced',
  },
	toNode: {
    default: null,
    hidden: true,
    section: 'Advanced',
	},
  fromPortId: {
    default: null,
    hidden: true,
    section: 'Advanced',
  },
  toPortId: {
    default: null,
    hidden: true,
    section: 'Advanced',
  },
};

module.exports = feeds;
